import { CheckCircle2 } from "lucide-react";

export default function PvOfferThanks() {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4" data-testid="pv-offer-thanks">
      <div className="max-w-md text-center space-y-4">
        <div className="inline-flex p-4 rounded-full bg-[#00E575]/20 text-[#00E575]">
          <CheckCircle2 size={64} />
        </div>
        <h1 className="font-display text-3xl font-bold">Vielen Dank!</h1>
        <p className="text-zinc-300 text-[15px]">
          Ihr Auftrag ist bei uns eingegangen. Wir melden uns innerhalb von 24 Stunden mit
          einem Termin für die Vor-Ort-Begehung.
        </p>
        <p className="text-zinc-400 text-sm font-medium">Bei Rückfragen erreichen Sie uns unter info@novatus-energie.de.</p>
      </div>
    </div>
  );
}
